// The "Export as image" pill beside the planning / estimate tabs.
import * as React from "react"
import { Dots } from "../toolkit/Dots"
import type { Approval, Project } from "../lib/auth"
import { saveImage } from "./exportImage"
import { t } from "./i18n"

export function SaveImageButton(props: { project: Project; kind: "planning" | "estimate"; clientName: string; logo?: string | null; approval?: Approval | null; lang?: "en" | "nl" }) {
    const [busy, setBusy] = React.useState(false)
    return (
        <button
            type="button"
            className="t-save nto-label"
            disabled={busy}
            onClick={async () => {
                setBusy(true)
                try {
                    await saveImage(props)
                } finally {
                    setBusy(false)
                }
            }}
            aria-label={props.kind === "planning" ? t("Export the planning as an image") : t("Export the estimate as an image")}
        >
            <span>{busy ? t("Saving…") : t("Export as image")}</span>
            <Dots shape="arrow" className="t-save-arrow" />
        </button>
    )
}
